export default "__VITE_ASSET__77c3d2fb__"